/**
 * LPH – Carnet offert, part 2 of 2 (part 1: snippets/lph-gift-cart.liquid).
 *
 * Rule: a cart with at least one La Mitaine Maille Libre holds exactly one « Le Carnet du Pouce
 * Heureux » (0 €, digital, no shipping). A cart without a mitaine holds none.
 *
 * When: after every cart write (theme, Kaching Bundles or any other app, noted by the watcher in
 * the snippet), after Dawn's cart-update events, and on page load when Liquid saw a wrong state.
 * What: reads /cart.js, adds or removes the Carnet or sets it back to 1, then redraws the cart
 * drawer, the /cart page and the cart count with Shopify's Section Rendering API.
 */
(function () {
  'use strict';

  var cfg = window.lphGiftConfig;
  if (!cfg || !cfg.variantId) return;

  var nativeFetch = window.lphNativeFetch || window.fetch.bind(window);
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var JSON_HEADERS = { 'Content-Type': 'application/json', Accept: 'application/json' };

  var timer = null;
  var running = false;
  var again = false;
  var pausedUntil = 0;
  var writes = [];
  var lastCart = null;

  function isGift(item) {
    return item.variant_id === cfg.variantId || item.handle === cfg.handle;
  }

  function isTrigger(item) {
    return cfg.triggers.indexOf(item.handle) !== -1 && item.quantity > 0;
  }

  function schedule(delay) {
    clearTimeout(timer);
    timer = setTimeout(run, typeof delay === 'number' ? delay : 300);
  }

  function run() {
    if (running) {
      again = true;
      return;
    }
    running = true;
    reconcile()
      .catch(function (error) {
        console.warn('[LPH Carnet]', error);
      })
      .then(function () {
        running = false;
        if (again) {
          again = false;
          schedule(150);
        }
      });
  }

  function getCart() {
    return nativeFetch(root + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(
      function (response) {
        return response.json();
      }
    );
  }

  // What has to change so the cart follows the rule, or null when it already does.
  function plan(cart) {
    var gifts = cart.items.filter(isGift);
    var updates = {};
    var needed = false;
    if (cart.items.some(isTrigger)) {
      if (!gifts.length) return { add: true };
      gifts.forEach(function (line, index) {
        var wanted = index === 0 ? 1 : 0;
        if (line.quantity !== wanted) {
          updates[line.key] = wanted;
          needed = true;
        }
      });
    } else {
      gifts.forEach(function (line) {
        updates[line.key] = 0;
        needed = true;
      });
    }
    return needed ? { updates: updates } : null;
  }

  // At most 8 corrections a minute, so an unexpected server answer can never cause a loop.
  function mayWrite() {
    var now = Date.now();
    if (now < pausedUntil) return false;
    writes = writes.filter(function (time) {
      return now - time < 60000;
    });
    if (writes.length >= 8) return false;
    writes.push(now);
    return true;
  }

  function write(change) {
    var request = change.add
      ? nativeFetch(root + 'cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: JSON_HEADERS,
          body: JSON.stringify({ items: [{ id: cfg.variantId, quantity: 1 }] }),
        })
      : nativeFetch(root + 'cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: JSON_HEADERS,
          body: JSON.stringify({ updates: change.updates }),
        });
    return request.then(function (response) {
      if (!response.ok) {
        // e.g. the Carnet is not available in this market: stop trying for 5 minutes.
        pausedUntil = Date.now() + 300000;
        return response.text().then(function (text) {
          throw new Error('cart write refused (' + response.status + '): ' + text.slice(0, 200));
        });
      }
    });
  }

  function reconcile() {
    return getCart().then(function (cart) {
      var change = plan(cart);
      if (!change) {
        lastCart = cart;
        checkDom();
        return;
      }
      if (!mayWrite()) return;
      return write(change)
        .then(getCart)
        .then(function (fresh) {
          lastCart = fresh;
          return render(fresh);
        })
        .then(checkDom);
    });
  }

  function parse(html) {
    return new DOMParser().parseFromString(html, 'text/html');
  }

  function swap(target, sourceDoc, selector) {
    if (!target || !sourceDoc) return;
    var source = sourceDoc.querySelector(selector);
    if (source) target.innerHTML = source.innerHTML;
  }

  // Redraw the same parts Dawn redraws after a quantity change (cart.js updateQuantity).
  function render(cart) {
    var drawer = document.querySelector('cart-drawer');
    var bubble = document.getElementById('cart-icon-bubble');
    var pageItems = document.getElementById('main-cart-items');
    var pageFooter = document.getElementById('main-cart-footer');
    var ids = [];
    if (drawer) ids.push('cart-drawer');
    if (bubble) ids.push('cart-icon-bubble');
    if (pageItems && pageItems.dataset.id) ids.push(pageItems.dataset.id);
    if (pageFooter && pageFooter.dataset.id) ids.push(pageFooter.dataset.id);
    if (!ids.length) return Promise.resolve();

    // No « Accept: application/json » here: on a product URL Shopify would then answer with the
    // product's JSON instead of the rendered sections.
    var url = window.location.pathname + '?sections=' + encodeURIComponent(ids.join(','));
    return nativeFetch(url, { credentials: 'same-origin' })
      .then(function (response) {
        return response.json();
      })
      .then(function (sections) {
        var empty = cart.item_count === 0;
        if (drawer && sections['cart-drawer']) {
          swap(drawer.querySelector('.drawer__inner'), parse(sections['cart-drawer']), '.drawer__inner');
          drawer.classList.toggle('is-empty', empty);
        }
        if (bubble && sections['cart-icon-bubble']) {
          swap(bubble.querySelector('.shopify-section') || bubble, parse(sections['cart-icon-bubble']), '.shopify-section');
        }
        if (pageItems && sections[pageItems.dataset.id]) {
          swap(
            pageItems.querySelector('.js-contents'),
            parse(sections[pageItems.dataset.id]),
            '#main-cart-items .js-contents'
          );
          var cartItems = pageItems.closest('cart-items');
          if (cartItems) cartItems.classList.toggle('is-empty', empty);
        }
        if (pageFooter && sections[pageFooter.dataset.id]) {
          swap(pageFooter.querySelector('.js-contents'), parse(sections[pageFooter.dataset.id]), '.js-contents');
          pageFooter.classList.toggle('is-empty', empty);
        }
      });
  }

  // An app may redraw the drawer with an older copy of the cart just after our redraw.
  // Check once, a moment later, that the Carnet line matches the cart, and redraw if not.
  var domTimer = null;
  function checkDom() {
    clearTimeout(domTimer);
    domTimer = setTimeout(function () {
      if (!lastCart) return;
      var shouldShow = lastCart.items.some(isTrigger) && lastCart.items.some(isGift);
      var drawerItems = document.querySelector('cart-drawer .cart-items');
      var pageItems = document.querySelector('#main-cart-items .cart-items');
      var containers = [drawerItems, pageItems].filter(Boolean);
      var stale = containers.some(function (container) {
        return !!container.querySelector('.lph-gift-line') !== shouldShow;
      });
      if (stale) render(lastCart);
    }, 1200);
  }

  function start() {
    var queue = window.lphGiftQueue || [];
    document.addEventListener('lph:cart-written', function () {
      schedule(300);
    });
    // Dawn's pubsub (also used by Shopify's Standard Actions cart updates). PUB_SUB_EVENTS is a
    // top-level const in constants.js, so it is not a property of window.
    /* global subscribe, PUB_SUB_EVENTS */
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        if (!event || event.source !== 'lph-gift') schedule(300);
      });
    }
    if (cfg.needsFix || queue.length) schedule(0);
  }

  window.lphGift = { check: run };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
